<template>
  <v-autocomplete
    :value="value"
    :items="buildingComplexList"
    :label="$t('BUILDING_COMPLEXES.ITEMS')"
    :search-input.sync="search"
    :counter="counter"
    :menu-props="menuProps"
    item-value="id"
    item-text="name"
    multiple
    chips
    small-chips
    deletable-chips
    append-outer-icon="mdi-close"
    v-bind="$attrs"
    v-on="listeners"
  ></v-autocomplete>
</template>

<script>
import { mapCacheActions } from 'vuex-cache';
import clearableSelectFilter from '../filters/mixins/clearableSelectFilter';

export default {
  name: 'BuildingComplexFilter',

  mixins: [clearableSelectFilter],

  data() {
    return {
      buildingComplexList: []
    };
  },

  mounted() {
    this.retrieveBuildingComplexesList().then(({ data }) => {
      this.buildingComplexList = data.data;
    });
  },

  methods: {
    ...mapCacheActions('building_complex', ['retrieveBuildingComplexesList'])
  }
};
</script>

<style scoped></style>
